export const REQUIRED_FIELD = 'Поле обязательно к заполнению';
export const IS_EMAIL = 'Введите корректный Email';
